import { render, staticRenderFns } from "./param-bon-consultations.html?vue&type=template&id=a325208c&scoped=true&external"
import script from "./param-bon-consultations.js?vue&type=script&lang=js&external"
export * from "./param-bon-consultations.js?vue&type=script&lang=js&external"
import style0 from "./param-bon-consultations.scss?vue&type=style&index=0&id=a325208c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a325208c",
  null
  
)

export default component.exports